import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'pf-select',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatInputModule, FormsModule],
  templateUrl: './select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './select.component.scss',
})
export class SelectComponent {
  // When sending options for the select, follow the format below, value is the value of the option, viewValue is displayed in the dropdown select.
  @Input() options = [
    { value: '', viewValue: '' },
  ];
  @Input() label = '';
  @Input() value = this.options[0].value;
  @Input() inputFormControl: FormControl | null = null;
  @Input() disabled: boolean = false;

  @Output() onChange = new EventEmitter();
  selectControl = new FormControl(this.value);

  public ngOnInit() {
    if (this.options.length) {
      this.selectControl.setValue(this.options[0].value)
    }


    if (this.inputFormControl) {
      this.selectControl = this.inputFormControl;
    }

    this.selectControl.valueChanges.subscribe(change => {
      this.onChange.emit(this.selectControl);
    });
  }
}
